<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <h1>Nefrite Lúpica - <small>Capítulo 01</small></h1>
          <iframe
            src="https://docs.google.com/presentation/d/e/2PACX-1vRMYU13JZv6EfhQClBGksYdfc51O-goy_8B4Ctc5YKSusbOAR7ii0GQeLhPfR23bg/embed?start=false&loop=false&delayms=3000"
            frameborder="0"
            width="100%"
            height="600"
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </b-col>
      </b-row>
    </b-container>

    <b-container>
      <b-row align-h="center" class="text-center">
        <b-col sm="12" md="3">
          <router-link to="/nefrite-lupica" class="pagination-link">ANTERIOR</router-link>
          <router-link to="/nefrite-lupica/capitulo-02" class="pagination-link">CAPITULO 02</router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Capitulo01"
};
</script>

<style scoped>
.list-item {
  list-style-type: square;
  list-style-position: inside;
  text-align: justify;
}
.list-img {
  list-style-type: decimal-leading-zero !important;
  list-style-position: outside !important;
}
.pagination {
  margin: 0;
}
.pagination-link {
  margin-right: 15px;
}
</style>